// extracted by mini-css-extract-plugin
export var alternate = "_1e-j";
export var black = "_1e-6";
export var blue = "_1e-f";
export var blueLight = "_1e-e";
export var brand = "_1e-8";
export var darkMode = "_1e-b";
export var error = "_1e-a";
export var gray = "_1e-5";
export var grayBlue = "_1e-d";
export var iconWrapper = "_1e-3";
export var inactive = "_1e-7";
export var indigo = "_1e-g";
export var orange = "_1e-i";
export var pink = "_1e-h";
export var primary = "_1e-0";
export var purple = "_1e-9";
export var success = "_1e-4";
export var warning = "_1e-c";
export var white = "_1e-1";
export var whiteSuccess = "_1e-2";